import { NAV_ITEMS } from "@/lib/constants";

interface MenuOverlayProps {
  isOpen: boolean;
  onNavigate: (path: string) => void;
}

export function MenuOverlay({ isOpen, onNavigate }: MenuOverlayProps) {
  return (
    <div
      className={`fixed inset-0 bg-[#C06B5D] text-[#ECE9E0] z-40 flex flex-col justify-center px-6 md:px-24 transition-transform duration-700 ease-[cubic-bezier(0.77,0,0.175,1)] ${
        isOpen ? "translate-y-0" : "-translate-y-full"
      }`}
    >
      <div className="max-w-4xl w-full mx-auto space-y-6 text-center">
        {NAV_ITEMS.map((item) => (
          <div key={item.path} className="overflow-hidden">
            <button
              onClick={() => onNavigate(item.path)}
              className="inline-block font-serif text-4xl md:text-7xl hover:italic transition-all uppercase tracking-wide hover:text-[#293129]"
            >
              {item.name}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
